<template>
  <div
    class="forgot-password-modal"
    v-loading="isLoading"
  >
    <app-i18n
      class="forgot-password-modal__title"
      code="auth.forgotPassword.message"
    />
    <div class="forgot-password-modal__title-separator" />

    <el-form
      v-if="model"
      class="forgot-password-modal__form forgot-password-modal__form--compact"
      :model="model"
      label-position="top"
      :rules="rules"
      ref="form"
      @submit.prevent.native="doSubmit"
      @keypress.enter.native="doSubmit"
    >
      <el-row>
        <!-- Email -->
        <el-col :lg="24" :md="24" :sm="24">
          <el-form-item
            :label="fields.email.label"
            :prop="fields.email.name"
            :required="fields.email.required"
          >
            <el-input
              v-model="model[fields.email.name]"
              :placeholder="i18n('user.placeholders.email')"
              prefix-icon="icon-mail"
            />
          </el-form-item>
        </el-col>

        <!-- Global error message -->
        <el-col :lg="24" :md="24" :sm="24">
          <el-form-item
            class="forgot-password-modal__form__global-error"
            v-if="globalErrorMessage"
            :error="globalErrorMessage"
          />
        </el-col>

        <!-- Form controls -->
        <el-col :lg="24" :md="24" :sm="24">
          <el-form-item class="forgot-password-modal__form__controls">
            <el-button
              type="primary"
              @click="doSubmit"
              :disabled="isLoading"
            >
              <app-i18n code="auth.passwordResetEmail.message" />
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import { forgotPassword } from '@/auth'

import { i18n } from '@shared/i18n'
import { FormSchema } from '@shared/form/form-schema'

import { UserModel } from '@modules/auth/user-model'

export default {
  name: 'forgot-password-modal',
  data() {
    return {
      model: {},
      globalErrorMessage: null,
      isLoading: false,
      i18n,
    }
  },
  created () {
    console.log(window.location.href);
  },

  computed: {
    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    
    formSchema() {
      const { fields } = this;
      return new FormSchema([
          fields.email,
      ]);
    },

    fields() {
      return new UserModel().fields();
    },
  },
  methods: {
    ...mapMutations({
      setForgotPasswordModalVisible: 'setForgotPasswordModalVisible',
      setSuccessModalVisible: 'setSuccessModalVisible',
      setSuccessModalType: 'setSuccessModalType',
      setLockDialog: 'setLockDialog',
    }),
    async doSubmit($event) {
      if ($event) $event.preventDefault()

      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }

      try {
        this.isLoading = true
        
        const originUrl = window.location.href
        await forgotPassword(this.model.email, originUrl)
        this.onSuccess()
      } catch (e) {
        if (e.networkError && e.networkError.result && e.networkError.result.errors && e.networkError.result.errors.length) {
          if (e.networkError.result.errors[0].errorCode === 'email/unknown') this.globalErrorMessage = i18n('iam.errors.emailNotFound')
          else this.globalErrorMessage = i18n('common.unknownError')
        } else if (e.graphQLErrors && e.graphQLErrors instanceof Array && e.graphQLErrors.length) {
          const { errorCode } = e.graphQLErrors[0]
          this.globalErrorMessage = i18n(`auth.forgotPassword.error.${errorCode}`)
        } else {
          this.globalErrorMessage = i18n('common.unknownError')
        }
      } finally {
        this.isLoading = false
      }
    },
    onSuccess() {
      this.setSuccessModalType('resetPassword')
      this.setSuccessModalVisible(true)
      this.setForgotPasswordModalVisible(false)
      },
    onLoadingChange(isLoading) {
      this.setLockDialog(isLoading)
    },
  },
  watch: {
    isLoading: {
      handler: 'onLoadingChange',
      immediate: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.forgot-password-modal {
  @include modal-mixin;

  &__form {
    body .el-form &__controls {
      margin-bottom: 0;
    }
  }
}
</style>
